const scrollers = document.querySelectorAll('.scroller');
if (scrollers) {
  addAnimation();
}

function addAnimation () {
  scrollers.forEach((scroller) => {
    const scrollerInner = scroller.querySelector('.scroller__inner');
    const scrollerContent = Array.from(scrollerInner.children);

    const duplicates = 3;
    for (let i = 0; i < duplicates; i++) {
      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        duplicatedItem.setAttribute('aria-hidden', true);
        scrollerInner.appendChild(duplicatedItem);
      });
    }
  });
}
